import axios from 'axios';
import miscFunctions from '../helpers/misc-functions';
import apiFilters from '../helpers/apiFilterConstants.js';

let helpers = {

  getUserProjects: (page, perPage, user, company_id) => {
    let request = null;
    if (page) {
      request = process.env.REACT_APP_API + '/projects/all_assigned_projects?current_company=' + (company_id ? company_id : localStorage.current_company_id) + (user ? '&user_id=' + user.id : '') + '&page=' + page + '&per=' + (perPage ? perPage : 7);
    }
    else {
      request = process.env.REACT_APP_API + '/projects/all_assigned_projects?current_company=' + (company_id ? company_id : localStorage.current_company_id) + (user ? '&user_id=' + user.id : '');
    }

    request += '&filtering=' + apiFilters.projectFilters.projectCollectionShallow.encodedFilter;

    return axios({
      method: 'get',
      url: request,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        if (response.data.data) {
          if (response.data.meta) {
            let record = miscFunctions.mapApiJson(response.data);
            record = apiFilters.projectFilters.projectCollectionShallow.postProcess(record);
            return {
              projects: record, lastProjectsPage: parseInt(response.data.meta.last_page, 10), totalProjects: parseInt(response.data.meta.total_projects, 10),
              completedProjects: parseInt(response.data.meta.completed_projects, 10),
            };
          }
          else {
            let record = miscFunctions.mapApiJson(response.data);
            record = apiFilters.projectFilters.projectCollectionShallow.postProcess(record);
            return record;
          }
        }
        else {
          return {
            projects: response.data.projects,
            lastMyProjectsPage: parseInt(response.data.meta.last_page, 10),
            totalMyProjects: parseInt(response.data.meta.total_projects, 10),
            completedMyProjects: parseInt(response.data.meta.completed_projects, 10),
          };
        }
      })
      .catch(error => {
        return { error: error };
      });
  },
};

export default helpers;



// WEBPACK FOOTER //
// ./src/services/projectsServiceOld.js